import _ from 'lodash';
import googleFontsAPI from 'ub/fonts/font-service/google/api';
import googleFonts from 'ub/fonts/font-service/google/fonts';
import {cleanQuotes} from './font-data-normalizer.js';

const stripFallbackFonts = (fontString) => {
  const numCharactersToSplit = 1;

  return fontString
    .split(',', numCharactersToSplit)
    .shift()
    .trim()
    .toLowerCase();
};

const cleanFontString = (fontString) => {
  return cleanQuotes(stripFallbackFonts(fontString))
    .replace(/\s+/g, ' ')
    .trim();
};

const findValidFontName = (allowedFonts, fontName) => {
  return _.find(allowedFonts, (allowedFont) => {
    return allowedFont.toLowerCase() === fontName.toLowerCase();
  });
};

const mergeFontObjs = (webFontSet) => {
  const mergeCustomizer = (objValue, srcValue) => {
    if ( _.isArray(objValue)) {
      return objValue.concat(srcValue);
    }
  };

  return _.merge({}, ...webFontSet, mergeCustomizer);
};

const removeDuplicateWeights = (fontMap) => {
  const list = _.map(fontMap, (fontWeights, fontFamily) => {
    const fontObj = {};

    fontObj[fontFamily] = _.uniq(fontWeights);

    return fontObj;
  });

  return mergeFontObjs(list);
};

const getComputedFontStyles = (elm) => {
  const elmStyles = window.getComputedStyle(elm, null);
  const cleanFontName = cleanFontString(elmStyles.fontFamily);
  const matchedFont = googleFontsAPI.findFontInList(cleanFontName);

  const family = matchedFont ? matchedFont.family : cleanFontName;

  // These are forced to false as this property is only useful for buttons and
  // form labels where we are getting the property from the pom. With text, calling
  // getComputedStyle on the dom nodes should already give us the accurate weight and style
  const textStyles = {
    strong: false,
    em: false
  };

  return {
    family,
    weight: elmStyles.fontWeight,
    style: elmStyles.fontStyle,
    textStyles
  };
};

const formatWebFonts = (webFontSet) => {
  return _.map(webFontSet, (fontWeights, fontFamily) => {
    const fontWeightsString = _.unique(fontWeights).join(',');
    return `'${fontFamily}:${fontWeightsString}'`;
  });
};

const formatForWebfontLoader = (fonts) => {
  return _.map(fonts, ({family, variants}) => {
    return `${family}:${_.pluck(variants, 'name').join(',')}`;
  });
};

const getFormattedFontFamily = (family) => {
  // If font family name contains a number we need to wrap it in single quotes
  if (/\d/.test(family)) {
    return `'${family}'`;
  }
  return family;
};

export default {
  sysFonts: [
    {label: "Arial", value: "Arial, sans-serif"},
    {label: "Comic Sans MS", value: 'Comic Sans MS, cursive, sans-serif'},
    {label: "Courier New", value: 'Courier New, Courier, monospace'},
    {label: "Georgia", value: "Georgia, serif"},
    {label: "Lucida Sans Unicode", value: 'Lucida Sans Unicode, Lucida Grande, sans-serif'},
    {label: "Tahoma", value: "Tahoma, Geneva, sans-serif"},
    {label: "Times New Roman", value: 'Times New Roman, Times, serif'},
    {label: "Trebuchet MS", value: 'Trebuchet MS, sans-serif'},
    {label: "Verdana", value: "Verdana, Geneva, sans-serif"}
  ],

  get sysFontsNames() {
    return _.pluck(this.sysFonts, "label");
  },

  get webFontsNames() {
    return googleFonts.fontFamilies;
  },

  get webFonts() {
    return _.map(this.webFontsNames, (font) => {
      return {
        label: font,
        value: font
      };
    });
  },

  get allFonts() {
    return this.sysFonts.concat(this.webFonts);
  },

  get allowedFonts() {
    return this.sysFontsNames.concat(this.webFontsNames);
  },

  getBaseFontFamily(fontString) {
    return findValidFontName(this.allowedFonts, cleanFontString(fontString));
  },

  // TODO: copied over from legacy, DO NOT publish this way
  buildFontList() {
    return "";
  },
  formatWebFonts,
  formatForWebfontLoader,
  getFormattedFontFamily,
  cleanFontString,
  mergeFontObjs,
  getComputedFontStyles,
  removeDuplicateWeights
};



// WEBPACK FOOTER //
// ./src/fonts/font-service/utils-new.js